import { useLoaderData, useLocation, useNavigate } from 'react-router-dom'
import { ArrowShortIcon } from 'assets/icons'
import Image1 from 'assets/images/allinone-actor.png'
import Image2 from 'assets/images/allinone-cd.png'
import Image3 from 'assets/images/allinone-agency.png'
import { t } from 'helpers'
import { HOME_PAGES, PATHS } from 'types/enums'
import s from './index.module.scss'

const AllInOne = (): JSX.Element => {
	const { pathname } = useLocation()
	const registration = pathname?.includes(PATHS.REGISTER)
	const navigate = useNavigate()

	// 	const registerAs = (type: 'agency' | 'director'): void => {
	// 		navigate(window.location.pathname + '?as=' + type)
	// 	}

	// <div className={s.options}>
	// 					<span
	// 						className="caption-r"
	// 						style={{ textAlign: 'center' }}
	// 						onClick={() => registerAs('agency')}>
	// 						{t('APP_REGISTER_AGENCY_LABEL')}
	// 					</span>
	// 					<span
	// 						className="caption-r"
	// 						style={{ textAlign: 'center' }}
	// 						onClick={() => registerAs('director')}>
	// 						{t('APP_REGISTER_CASTINGDIRECTOR_LABEL')}
	// 					</span>
	// 				</div>

	const items = [
		{
			image: Image1,
			label: t('APP_HOME_ALLINONE_ACTOR'),
			onClick: () => {
				if (registration) {
					navigate('/' + PATHS.JOIN + '/' + PATHS.LOGIN)
				} else {
					navigate('/' + PATHS.HOME + '/' + HOME_PAGES.ACTOR)
				}
			},
		},
		{
			image: Image2,
			label: t('APP_HOME_ALLINONE_CD'),
			onClick: () => {
				if (registration) {
					navigate(window.location.pathname + '?as=director')
				} else {
					navigate('/' + PATHS.HOME + '/' + HOME_PAGES.CD)
				}
			},
		},
		{
			image: Image3,
			label: t('APP_HOME_ALLINONE_AGENCY'),
			onClick: () => {
				if (registration) {
					navigate(window.location.pathname + '?as=agency')
				} else {
					navigate('/' + PATHS.HOME + '/' + HOME_PAGES.AGENCY)
				}
			},
		},
	]

	return (
		<section className={s.container}>
			<h2>
				{t(
					registration ? 'APP_LOGIN_WELCOME_TITLE' : 'APP_HOME_ALLINONE_TITLE',
				)}
			</h2>
			<div className={s.wrapper}>
				{items?.map((item) => (
					<div className={s.item} key={item.label} onClick={item.onClick}>
						<img src={item.image} alt="allinone" />
						<div className={s.titles}>
							<span>{t('APP_HMOE_ALLINONE_SUBTITLE')}</span>
							<div>
								<div
									style={{
										backgroundColor: 'var(--elev300)',
										filter: 'blur(30px)',
										position: 'absolute',
										width: '100%',
										height: '100%',
										top: '0',
										left: '0',
										zIndex: -1,
									}}
								/>
								{registration ? (
									<h3 style={{ whiteSpace: 'nowrap' }}>{item.label}</h3>
								) : (
									<h2>{item.label}</h2>
								)}
								<div style={{ display: 'flex' }}>
									<ArrowShortIcon width="20" height="20" />
								</div>
							</div>
						</div>
					</div>
				))}
			</div>
		</section>
	)
}

export default AllInOne
